import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

export default {
  // Get the safe data from backend and store it back in the store
  updateSafe(cb) {
    axios
      .get("/api/app/safe")
      .then(({ data }) => {
        cb(data);
      })
      .catch(handleAxiosError);
  },
};
